import { useFloating as m, autoUpdate as y } from "@floating-ui/react-dom";
import { SfPopoverPlacement as f, SfPopoverStrategy as u } from "@storefront-ui/shared";
function P(t) {
  const {
    isOpen: e,
    middleware: o,
    placement: r = f.bottom,
    strategy: a = u.absolute
  } = t, { refs: n, strategy: s, x: i, y: l, middlewareData: p } = m({
    strategy: a,
    placement: r,
    open: e,
    middleware: o,
    whileElementsMounted: y
  });
  return { refs: n, style: {
    position: s,
    top: l,
    left: i
  }, middlewareData: p };
}
export {
  P as usePopover
};
